import { TimePicker } from 'antd';
import dayjs from 'dayjs';

interface ActivityTimeInputProps {
    value?: string;
    onChange?: (value: string) => void;
}

const ActivityTimeInput: React.FC<ActivityTimeInputProps> = ({ value, onChange }) => {
    const handleChange = (time: dayjs.Dayjs | null) => {
        onChange?.(time ? time.format('HH:mm') : '');
    };

    return (
        <TimePicker
            format="HH:mm"
            style={{ width: '100%' }}
            value={value ? dayjs(`2000-01-01 ${value}`) : null}
            minuteStep={30}
            needConfirm={false}
            onChange={handleChange}
            disabledHours={() => Array.from({ length: 6 }, (_, i) => i)}
            showNow={false}
        />
    );
};

export default ActivityTimeInput;
